module.exports = __webpack_public_path__ + "img/supplyBanner.6a743e42.png";